import { Container } from 'unstated';
import { getPersistentStore, getPersistentStoreMutex } from '@lemonadefashion/storage';

// Never ever forget that for 2 years, users accumulated
// lf_auth_token and fb_auth_token keys in their local storage.
// const LF_KEY = 'lf_auth_token';
// const FB_KEY = 'fb_auth_token';
const KEY = '_auth_token';
function _getStore() { return getPersistentStore(); }
function _getMutex() { return getPersistentStoreMutex(); }

function _adapt(authInfo) {
  return {
    tokenType: authInfo.tokenType ?? authInfo.token_type ?? null,
    authToken: authInfo.authToken ?? authInfo.auth_token ?? null
  };
}

function getAuthTokenInfoFromStore() {
  try {
    const infoJson = _getStore().getItem(KEY);
    if (infoJson == null) return {};
    return _adapt(JSON.parse(infoJson));
  } catch (error) {
    console.log(error);
    return {};
  }
}

function updateAuthTokenInfoInStore(tokenType, authToken) {
  return new Promise((resolve, reject) => {
    const mutex = _getMutex();
    const store = _getStore();
    mutex.lock(KEY)
      .then(() => {
        store.setItem(KEY, JSON.stringify({ tokenType: tokenType, authToken: authToken }));
        return mutex.release(KEY).then(resolve).catch(reject);
      })
      .catch(reject);
  });
}

function clearAuthTokenInfoFromStore() {
  return new Promise((resolve, reject) => {
    const mutex = _getMutex();
    const store = _getStore();
    mutex.lock(KEY)
      .then(() => {
        store.removeItem(KEY);
        return mutex.release(KEY).then(resolve).catch(reject);
      })
      .catch(reject);
  });
}

class AuthTokenContainer extends Container {
  constructor() {
    super();

    // We store the tokens as data members of the class,
    // because the App render should essentially never be
    // a direct function of the tokens present here.
    const info = getAuthTokenInfoFromStore();
    this.activeTokenType = info.tokenType;
    this.activeToken = info.authToken;

    window.addEventListener('storage', (e) => {
      if (e.key !== KEY) return;
      const info = getAuthTokenInfoFromStore();
      this.activeTokenType = info.tokenType;
      this.activeToken = info.authToken;
    });
  }

  getActiveToken() { return this.activeToken ?? null; }
  getActiveTokenType() { return this.activeTokenType ?? null; }

  setActiveToken(tokenType, authToken) {
    this.activeToken = authToken;
    this.activeTokenType = tokenType;
    return updateAuthTokenInfoInStore(tokenType, authToken);
  }

  clearActiveToken() {
    if (this.getActiveToken() == null) return Promise.resolve();
    this.activeToken = null;
    this.activeTokenType = null;
    return clearAuthTokenInfoFromStore();
  }
}

export default AuthTokenContainer;
